export const dealershipKeys = {
  all: ['dealerships'],
  dealership: (id?: number, includes?: string[]) => [...dealershipKeys.all, id, includes],
}
